import {call, put} from 'redux-saga/effects';

import axios from 'axios';
import * as lexActionType from '../actionsType/lexLogin.actionType';
import {getBaseUrl} from '../../../core/utility/filter.utility';

function loginUser(reqObj) {
    if (typeof reqObj === 'boolean') {
        return axios({
            method: 'post',
            url: `${getBaseUrl()}/cls/login/CATCmaUserAthenticationServlet/termsOfUse`,
            data: {
                tnc: reqObj
            }
        });
    }
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/cls/login/CATCmaUserAthenticationServlet/login`,
        data: {
            username: reqObj.username,
            userpassword: reqObj.userpassword,
            lpId: reqObj.lpId
        }
    });
}

export function* loginUserSaga(request) {
    try {
        const response = yield call(loginUser, request.payload);
        const content = response.data;
        if (content.res && content.res.includes('success')) {
            yield put({
                type: lexActionType.LOGIN_SUCCESS,
                payload: content
            });
        } else if (content.res && content.res.includes('CATCmaTermsofUse')) {
            yield put({
                type: lexActionType.LOGIN_MID,
                payload: content
            });
        } else if (content && content.includes('success')) {
            yield put({
                type: lexActionType.LOGIN_SUCCESS,
                payload: content
            });
        } else if (content === 'logout') {
            yield put({
                type: lexActionType.LOGOUT,
                payload: content
            });
        } else if (content === 'changePassword') {
            yield put({
                type: lexActionType.LOGIN_SUCCESS,
                payload: content
            });
        } else {
            yield put({
                type: lexActionType.LOGIN_ERROR,
                payload: 'Bad Login/Password'
            });
        }
    } catch (error) {
        yield put({
            type: lexActionType.LOGIN_ERROR,
            payload: 'There has been some issue with 3DS Learning Space. Please try after sometime.'
        });
    }
}
